import { VerifyUserResponse } from "@syla/shared/types/responses/VerifyUserResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function verify(token: string): Promise<VerifyUserResponse> {
  try {
    const response = await axios.post<VerifyUserResponse>("/users/verify", {
      token,
    });
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
